import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useDtpDetailModel } from "./dtpDetailModel";
import { RouterParamType } from "@/model/navModel";
import { IDtpTabEnum } from "../../dtpTypes";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { SupplierPrice } from "./price";
import { Files } from "./files";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useDtpDetailModel(({ tabActive }) => [tabActive]);
    const isEdit = detailsInfo.mode === "edit";

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case IDtpTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case IDtpTabEnum.SUPPLIER_PRICE:
                return <SupplierPrice {...detailsInfo} />;
            case IDtpTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case IDtpTabEnum.FILES:
                return <Files {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IDtpTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const action = <>
        <Button
            className={classname(IDtpTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDtpTabEnum.BASE_DETAIL)}
        >单据详情</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.SUPPLIER_PRICE)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDtpTabEnum.SUPPLIER_PRICE)}
        >供应商报价</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.RELEVANCE_TASK)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDtpTabEnum.RELEVANCE_TASK)}
        >关联单据</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDtpTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDtpTabEnum.FILES)}
        >附件管理</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== IDtpTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}